import React from "react";
import { Layout } from "antd";

const { Footer: AntFooter } = Layout;

function Footer() {
  return <AntFooter style={{ textAlign: "center", padding: "0" }}></AntFooter>;
}

export default Footer;
